'use client';

import { ToastProvider } from '@carvana/ds-toast';

interface ToastProviderWrapperProps {
  children: React.ReactNode;
}

export default function ToastProviderWrapper({
  children
}: ToastProviderWrapperProps) {
  return <ToastProvider>{children}</ToastProvider>;
}
